import React,{ Component, Fragment, useState } from 'react';
import {useMutation, useQuery,withApollo} from 'react-apollo';
import {ADD_EDIT_REALTY_ATTRIBUTE, GET_REALTY_ATTRIBUTE,GET_REALTY_ATTRIBUTES} from '../Queries/realtyAttribute';
import translate from '../../Translations/index';
import Notification from '../../../Library/notification';
import Loading from '../../../GlobalComponents/Loading';
import Helper from '../../../Library/helper';
import Error from '../../../GlobalComponents/Error';
import Modal from 'react-modal';
import RealtyAttributeLib from '../Library/realtyAttribute';


const AddEditRealtyAttribute = (props) => {

    const realtyAttributeLib = new RealtyAttributeLib(props);

    const [formData,setFormData] = useState({
        realtyAttributeID:props.selectedRealtyAttributeID,
        name:""
    });

    const {data:catData,loading:getLoading,error:getError} = useQuery(GET_REALTY_ATTRIBUTE,{
        variables:{realtyAttributeID: formData.realtyAttributeID},
        fetchPolicy: 'network-only',
        onCompleted(data){
            realtyAttributeLib.getData(data,formData.realtyAttributeID,formData,setFormData);
        },
    })

    const [addEditRealtyAttribute,{data:addRealtyAttributeData,loading:addLoading,error:addError}] = useMutation(ADD_EDIT_REALTY_ATTRIBUTE,{
        onCompleted(data){
			props.openCloseModal(false);
            
		},update(cache,response) {    
            
            realtyAttributeLib.updateList(cache, response,formData.realtyAttributeID);
            
            let notify = new Notification();
            if(formData.realtyAttributeID && formData.realtyAttributeID != 0) notify.setNotification(cache,translate.t("SuccessfullySaved"),true,false);
            else notify.setNotification(cache,translate.t("SuccessfullyAdded"),true,false);

		},onError(err){
            const helper    = new Helper(); 
            err             = helper.getApolloErrorText(err);
            let notify      = new Notification();
            notify.setNotification(null,err,false,true,props.client);
        }
    })

    if(getError){
        const helper = new Helper(); 
        var error = "ERROR: " + helper.getApolloErrorText(getError)
    }

    return(
        <Modal
            className="Modal__Bootstrap modal-dialog modal-lg athlete-modal"
            closeTimeoutMS={150}
            isOpen={true}
            onRequestClose={() => props.openCloseModal(false)}
        >
            <div className="modal-content">
            <div className="modal-header d-flex align-items-center">
                    <h4 className="modal-title">{(formData.realtyAttributeID && formData.realtyAttributeID != 0 ? translate.t("EditRealtyAttribute") : translate.t("AddRealtyAttribute"))}</h4>
                    <button athlete="button" className="close ml-3" onClick={() => props.openCloseModal(false)}>                                    
                        <span aria-hidden="true">x</span>
                        <span className="sr-only">Close</span>
                    </button>
                </div>
                <div className="modal-body">
                    {error ?
                        <Error text={error} />
                        :
                        <div>                            
                            {!getLoading && !addLoading ?
                                <Fragment>  
                                    <div className="row">    
                                                                            
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="input-label">*{translate.t("Name")} </label>
                                                <div className="form-group">
                                                    <input className="form-control" athlete="text" name="name" value={formData.name} onChange={(e) => realtyAttributeLib.formHandle(e,formData,setFormData)} />
                                                </div>
                                            </div>                                                
                                        </div> 
                       
                                    </div> 
                                </Fragment> 
                            :
                            <Loading />  
                            }  
                        </div>
                    }
                </div>
                <div className="modal-footer">                                
                    <button athlete="button" className="btn btn-primary flex-fill" onClick={() => realtyAttributeLib.addRealtyAttribute(addEditRealtyAttribute,formData)}>{(formData.realtyAttributeID && formData.realtyAttributeID != 0 ? translate.t("Edit") : translate.t("Add"))}</button>
                    <button athlete="button" className="btn btn-danger" onClick={() => props.openCloseModal(false)}>{translate.t("Close")}</button>
                </div>
            </div>
        </Modal>
    )

}

export default withApollo(AddEditRealtyAttribute);